// Readable constants for various special cases

export const CATEGORY_ID_UUTISET = 112
export const CATEGORY_ID_URHEILU = 109
export const CATEGORY_ID_IT = 20
export const CATEGORY_ID_PAIKALLISUUTISET = 54
